<template>
    <div class="badge" :class="{
        'badge-success': type === 'success', 'badge-danger': type === 'danger',
    }"><span>{{ label
}}</span></div>
</template>

<script >
export default {
    props: {
        type: String,
        label: String,
    },
}
</script>

<style scoped>
.badge {
    border: none;
    padding: 6px 12px;
    border-radius: 5px;
}

.badge span {
    background-color: transparent;
    font-size: 0.90rem;
    font-weight: 600;
}

.badge,
span {
    cursor: text;
}

.badge-success {
    color: rgb(35, 92, 35);
    background-color: rgba(69, 180, 69, 0.507);
}

.badge-danger {
    color: rgb(190, 30, 30);
    background-color: rgba(190, 30, 30, 0.404)
}
</style>




// WEBPACK FOOTER //
// src/components/Common/Badge/Badge.vue